import { Subject, merge, pipe } from 'rxjs';
import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { map, scan, shareReplay, takeUntil, withLatestFrom, tap, distinctUntilChanged } from 'rxjs/operators';

var ActionTypes;
(function (ActionTypes) {
    ActionTypes[ActionTypes["OBJECT"] = 0] = "OBJECT";
    ActionTypes[ActionTypes["FUNCTION"] = 1] = "FUNCTION";
    ActionTypes[ActionTypes["FUNCTION_WITH_STATE"] = 2] = "FUNCTION_WITH_STATE";
})(ActionTypes || (ActionTypes = {}));
class Action {
    constructor(arg) {
        this.subject = new Subject();
        this.dispatch = (arg) => this.subject.next(arg);
        this.type = arg.length;
        this.command = arg;
    }
    static createDispatcher(schema) {
        return Object.entries(schema).reduce((actions, [actionName, action]) => (Object.assign(Object.assign({}, actions), { [actionName]: Action.create(action) })), {});
    }
    static create(action) {
        return action.command.length === ActionTypes.FUNCTION_WITH_STATE
            ? this.fromFunctionWithState(action.command)
            : this.fromFunction(action.command);
    }
    static fromFunction(fn) {
        return new Action(fn);
    }
    static fromFunctionWithState(fn) {
        return new Action(fn);
    }
}

class ActionUiService {
    constructor() {
        this._init = new Subject();
        this._ngOnDestroySubject = new Subject();
        this.dynamicCommand = new Subject();
        this.shouldDestroy = this._ngOnDestroySubject.asObservable();
    }
    initialize(state, actions) {
        this._dispatcher = actions;
        this.initialState = state;
        const { complex, simple } = this.segregateCommands();
        this._actionCreators = merge(this.dynamicCommand.asObservable(), this._init.pipe(map(() => (Object.assign({}, this.initialState)))), ...simple.map((action) => this.createSimpleCommand(action)));
        this.state = this._actionCreators.pipe(scan((state, command) => {
            return Object.assign(Object.assign({}, state), command);
        }, this.initialState), shareReplay(1));
        this.state
            .pipe(takeUntil(this._ngOnDestroySubject.asObservable()))
            .subscribe();
        merge(...complex.map((action) => this.createComplexCommand(action)))
            .pipe(takeUntil(this._ngOnDestroySubject.asObservable()))
            .subscribe();
        this._init.next({});
    }
    createSimpleCommand(action) {
        return action.subject.pipe(map((_action) => action.command(_action)));
    }
    createComplexCommand(action) {
        return action.subject.pipe(withLatestFrom(this.state), tap(([source, state]) => {
            this.dynamicCommand.next(action.command(source, state));
        }));
    }
    segregateCommands() {
        return Object.values(this._dispatcher).reduce((segregatedActions, action) => action.type === ActionTypes.FUNCTION_WITH_STATE
            ? {
                complex: [...segregatedActions.complex, action],
                simple: segregatedActions.simple,
            }
            : {
                complex: segregatedActions.complex,
                simple: [...segregatedActions.simple, action],
            }, {
            complex: [],
            simple: [],
        });
    }
    ngOnDestroy() {
        this._ngOnDestroySubject.next(true);
    }
}
ActionUiService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ActionUiService_Factory() { return new ActionUiService(); }, token: ActionUiService, providedIn: "root" });
ActionUiService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];

function pluck(key) {
    return pipe(map((state) => state[key]));
}
function queryChange(key) {
    return pipe(pluck(key), distinctUntilChanged());
}

class ActionUiModule {
}
ActionUiModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                exports: [],
            },] }
];

/*
 * Public API Surface of action-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Action, ActionTypes, ActionUiModule, ActionUiService, pluck, queryChange };
//# sourceMappingURL=lbmx-action-ui.js.map
